import { Pose } from "@mediapipe/pose";

let pose;

/**
 * Start pose detection on a video element, calling back with raw landmarks
 * on every frame. Drawing is handled externally by the caller so cycling-
 * specific overlays can be rendered instead of the default skeleton.
 */
const startCyclingPoseDetection = (videoElement, onResultsCallback, analyzerRef = null) => {
  if (!pose) {
    pose = new Pose({
      locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`,
    });

    pose.setOptions({
      modelComplexity: 2, // heavy model — better side-view accuracy
      smoothLandmarks: true,
      enableSegmentation: false,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });
  }

  pose.onResults((results) => {
    if (analyzerRef) {
      analyzerRef.current.incrementFrameCount();
    }
    
    if (!results.poseLandmarks) {
      onResultsCallback(null, false);
      return;
    }
    onResultsCallback(results.poseLandmarks);
  });

  const detectPose = async () => {
    if (videoElement.paused || videoElement.ended) {
      onResultsCallback(null, videoElement.ended);
      return;
    }

    await pose.send({ image: videoElement });
    requestAnimationFrame(detectPose);
  };

  detectPose();
};

export default startCyclingPoseDetection;
